import React from 'react';
import Link from '@material-ui/core/Link';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Title from '../../elements/Title';


const useStyles = makeStyles({
  depositContext: {
    flex: 1,
  },
});

export default function Cash(props) {
  const classes = useStyles();
  return (
    <>
    <React.Fragment>
      <Title>Cash Balance</Title>
      <Typography component="p" variant="h4">
        E{props.balance}
      </Typography>
      <Typography color="textSecondary" className={classes.depositContext}>
        last updated {props.lastUpdated}
      </Typography>
      <div>
        <Link color="primary" href="/accounting">
          View cash transactions
        </Link>
      </div>
    </React.Fragment>
    </>
  );
}